module.exports = __webpack_public_path__ + "img/Люмбоишиалгия.89933fd2.jpg";